import { StoreApi } from 'zustand'

// Type for stores that have a reset method
export interface ResettableStore {
  reset: () => void
}

// Registry to keep track of all stores that need to be reset
class StoreRegistry {
  private stores: Set<StoreApi<ResettableStore>> = new Set()

  // Register a store to be reset
  register<T extends ResettableStore>(store: StoreApi<T>): void {
    this.stores.add(store as StoreApi<ResettableStore>)
  }

  // Reset all registered stores
  resetAll(): void {
    this.stores.forEach(store => {
      store.getState().reset()
    })
  }
}

// Export a singleton instance
export const storeRegistry = new StoreRegistry() 